// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.new-mobile-apps-banner.banner {\n  padding: 10px 15px;\n}\n\n", ""]);
// Exports
module.exports = exports;
